import { Analytics } from "../../utils/analytics"
import { callFirebaseFunction } from "../callFirebaseFunction"

export const likeCruise = async (tripId: string, tripSearchId: string, docId: string) => {
  try {
    await callFirebaseFunction({
      name: "likeSearchResult",
      payload: { tripId, tripSearchId, tripSearchResultId: docId },
    })

    Analytics.logLikeCruise(docId)
  } catch (error) {
    console.error("liking cruise error", { error })
  }
}
